import { createContext, useContext } from 'react';

/**
 * AI token usage for the current tenant, shared by the header meter and any
 * page that wants to show or react to it.
 *
 * Default value keeps consumers safe outside a provider (e.g. the public survey
 * shell, which renders no header): they read "not configured" and render nothing.
 */
export const AiUsageContext = createContext({
  summary: null,
  byModel: [],
  loading: false,
  error: null,
  isConfigured: false,
  /** Server's verdict on whether this user may see cost figures (Client Admin / JLL). */
  canViewCost: false,
  refresh: () => {},
});

export const useAiUsage = () => useContext(AiUsageContext);

export default AiUsageContext;
